import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.replace";
import _defineProperty from "E:/workspaces/shop-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 登录功能
 */
import { mapGetters, mapActions, mapMutations } from 'vuex';
import FormMixins from '~/mixins/form-mixins';
import UploadMixins from '~/module/appUpdate/upload-mixins.js';
import api from 'api/update';
import AccountApi from 'api/login';
import securityCodeLogin from '~/module/securityCodeLogin';
import { GET_SCREEN, GET_PLUS_SDK } from '$getters';
import { SET_BACK_BUTTON_EVENT } from '$mutations';
import { LOGIN, WEICHATLOGIN, LOGINCODE } from '$actions';
export default {
  name: 'page-login',
  mixins: [FormMixins, UploadMixins],
  data: function data() {
    return {
      canWechatLogin_ios: false,
      canWechatLogin_android: false,
      loading: false,
      showPassword: true,
      aweixin: null,
      userinfo: {
        phone: null,
        password: null
      },
      userinfo2: {
        mobile: null,
        msgCode: null
      },
      routerPath: null,
      imgurl: '',
      num: '1',
      psLogin: '',
      codeLoginshow: ''
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    screen: GET_SCREEN,
    plusSdk: GET_PLUS_SDK
  })), {}, {
    params: function params() {
      return this.$route.params;
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations([SET_BACK_BUTTON_EVENT])), mapActions([LOGIN, LOGINCODE, WEICHATLOGIN])), {}, {
    passwordLogin: function passwordLogin() {
      var vm = this;
      api.getSysDictDataByDictType({
        id: 8
      }).then(function (res) {
        vm.psLogin = res.data.dictValue;
        console.log("密码登录=》》》》=============>>", vm.psLogin);
      });
    },
    codeLogin: function codeLogin() {
      var vm = this;
      api.getSysDictDataByDictType({
        id: 9
      }).then(function (res) {
        vm.codeLoginshow = res.data.dictValue;

        if (vm.codeLoginshow !== 'yes') {
          vm.num = '2';
        }

        console.log("密码登录=》》》》=============>>", vm.psLogin);
      });
    },
    doLogin: function doLogin() {
      var vm = this;
      vm.validateForm().then(function () {
        vm.loading = true;
        vm.LOGIN({
          mobile: vm.userinfo.phone,
          password: vm.userinfo.password
        }).then(function (res) {
          if (vm.params && vm.params['to']) {
            vm.$router.replace(vm.params.to);
          } else {
            if (vm.routerPath) {
              vm.$router.replace({
                path: vm.routerPath.path,
                params: vm.routerPath.params,
                name: vm.routerPath.name,
                query: vm.routerPath.query
              });
              console.log("登录返回前一个路由页", vm.routerPath);
            } else {
              // vm.$router.replace({path: '/'})                
              vm.$router.replace('/home');
            }
          }

          vm.loading = false;
        }).catch(function () {
          vm.loading = false;
          vm.getAppVersion();
        });
      });
    },
    //验证码登录
    docodeLogin: function docodeLogin() {
      var vm = this;
      vm.LOGINCODE({
        phone: vm.userinfo2.mobile,
        validCode: vm.userinfo2.msgCode
      }).then(function (res) {
        if (res.type === 'ERROR') {
          vm.$toast.error(res.message);
        } else {
          if (vm.params && vm.params['to']) {
            vm.$router.replace(vm.params.to);
          } else {
            if (vm.routerPath) {
              vm.$router.replace({
                path: vm.routerPath.path,
                params: vm.routerPath.params,
                name: vm.routerPath.name,
                query: vm.routerPath.query
              });
              console.log("登录返回前一个路由页", vm.routerPath);
            } else {
              // vm.$router.replace({path: '/'})                
              vm.$router.replace('/home');
            }
          }
        }

        vm.loading = false;
      }).catch(function () {
        vm.loading = false;
        vm.getAppVersion();
      }); // AccountApi.smsLogin({
      // 		phone: vm.userinfo2.mobile,
      // 		validCode: vm.userinfo2.msgCode
      // 	}).then(res => {
      //     console.log(res,"验证码登录======>>>>>>>>>>>=")
      //     if (res.type === 'ERROR') {
      //       vm.$toast.error(res.message)
      //       console.log('0000000')
      //     } else {
      //       console.log("111111")
      //       vm.LOGIN(res.data)
      //       if (vm.params && vm.params['to']) {
      //         vm.$router.replace(vm.params.to)
      //       } else {
      //         if (vm.routerPath) {                
      //           vm.$router.replace({path: vm.routerPath.path, params: vm.routerPath.params, name: vm.routerPath.name, query: vm.routerPath.query })
      //           console.log("登录返回前一个路由页",vm.routerPath)
      //         } else {          
      //           // vm.$router.replace({path: '/'})                
      //           vm.$router.replace('/home')
      //         }
      //       }
      //     }
      //     vm.loading = false
      //   }).catch(() => {
      //     vm.loading = false
      //     vm.getAppVersion()           
      //   })
    },
    regist: function regist() {
      this.$router.push('/register');
    },
    weichatLogin: function weichatLogin() {
      var vm = this;

      if (!vm.aweixin) {
        // Toast.fail("当前环境不支持微信登录");
        return;
      }

      vm.aweixin.authorize(function (e) {
        vm.code = e.code;
        var param = {};
        param.code = e.code;
        vm.WEICHATLOGIN(param).then(function (res) {
          if (res.type === 'SUCCESS') {
            if (vm.params && vm.params['to']) {
              vm.$router.replace(vm.params.to);
            } else {
              vm.$router.replace('/home');
            }
          } else {
            if (res.data && res.data.refresh_token) {
              vm.$router.replace({
                path: '/weichatBind',
                query: {
                  refresh_token: res.data.refresh_token
                }
              });
            }
          }

          vm.loading = false;
        }).catch(function () {
          vm.loading = false;
        });
      }, function (err) {// Toast.fail("授权失败："+JSON.stringify(err));
      }, {
        scope: 'snsapi_userinfo',
        state: 'authorize',
        appid: 'wxca815d3d291421b9'
      });
    },
    appDescribeimg: function appDescribeimg() {
      var vm = this;
      api.getSysDictDataByDictType({
        id: 7
      }).then(function (res) {
        vm.imgurl = res.data.dictValue;
        console.log("tupian=============>>", vm.imgurl);
      });
    }
  }),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    console.log(from); // this.routerPath = from

    next(function (vm) {
      vm.routerPath = from;
      next();
    });
  },
  mounted: function mounted() {
    var vm = this;
    vm.passwordLogin();
    vm.codeLogin();
    vm.appDescribeimg();

    if (vm.plusSdk.ready) {
      plus.oauth.getServices(function (services) {
        services.forEach(function (service) {
          if (service.id === 'weixin') {
            vm.aweixin = service;
          }
        });
      });
      vm.osname = window.plus.os.name;

      if (window.plus.os.name === 'iOS') {
        var UIApplication = plus.ios.importClass("UIApplication");
        var NSURL = plus.ios.importClass("NSURL");
        var app = UIApplication.sharedApplication();
        var bdScheme = NSURL.URLWithString("weixin://");
        var install = app.canOpenURL(bdScheme);
        vm.canWechatLogin_ios = install;
        plus.ios.deleteObject(bdScheme);
        plus.ios.deleteObject(app);
      }

      if (window.plus.os.name === 'Android') {
        vm.canWechatLogin_android = true;
      }
    }
  },
  components: {
    'security-code-login': securityCodeLogin
  }
};